module.exports = "<div class=\"loadingWrap\">\n  <render-component template=\"loading\"></render-component>\n</div>\n"